/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useState, useEffect} from "react";
import { Link, useParams } from "react-router-dom";
import {
  Alert,
  Button,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormSelect,
  FormInput,
  FormCheckbox,
  FormTextarea,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "shards-react";
import moment from 'moment-timezone'
import DatePicker from "react-datepicker";
import EventNoteIcon from '@mui/icons-material/EventNote';
import TimePicker from 'react-bootstrap-time-picker';
import { accessCheck } from "../../utils/tools";
import { WEB_PAYMENT_URL } from "../../environmentVariables";
import PageTitle from "../../components/common/PageTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH, faSortUp, faSortDown, faSearch, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { CONSTANTS } from "../../constants";
import "react-datepicker/dist/react-datepicker.css";
import { InsertInvitationOutlined } from "@mui/icons-material";
import { floor } from "lodash";
import ActivityIndicator from "../../components/common/ActivityIndicator";
import Pagination from "../../components/common/Pagination";

const PermittedVehicles = (props) => {
  let {locationId} = useParams();
  const [location, setLocation] = useState(props.locations.find(location => location.id === locationId));
  const [whitelist, setWhitelist] = useState([]);
  const [sortBy, setSortBy] = useState('licenseAsc')
  const [search, setSearch] = useState('')
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false)
  const [licensePlate, setLicensePlate] = useState('')
  const [licensePlateState, setLicensePlateState] = useState(location.state)
  const [startDate, setStartDate] = useState(moment().toDate())
  const [startTime, setStartTime] = useState(moment().format("HH:mm"))
  const [howLong, setHowLong] = useState('today')
  const [untilADate, setUntilADate] = useState(false)
  const [endDate, setEndDate] = useState(moment().add(1, 'days').toDate())
  const [page, setPage] = useState(1)
  const [pageSize] = useState(25)
  const [zone, setZone] = useState(null)
  const [tenants, setTenants] = useState(null)
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const [showImportVehicleModal, setShowImportVehicleModal] = useState(false)
  const [tenant, setTenant] = useState(null)
  const [csvFile, setCsvFile] = useState(null)
  const [showNotesModal, setShowNotesModal] = useState(false)
  const [notes, setNotes] = useState(location?.notes || null)
  const [showCsvTooltip, setShowCsvTooltip] = useState(false);

  useEffect(() => {
    props.getLocationWhitelist(location)
    props.getLocationTenants(location)
    document.title = 'Permitted vehicles: EnforcePlus admin';
    !accessCheck(props.user, 'locations') && (window.location.href = '/')
    return (() => props.clearWhitelist())
  }, [])

  useEffect(() => {
    setWhitelist(props.whitelist)
  }, [props.whitelist])

  // Add effect to respond to filter changes
  useEffect(() => {
    // When search query changes, make sure we're working with the latest data
    if (props.whitelist?.length > 0) {
      setWhitelist(props.whitelist);
    }
  }, [search]);

  useEffect(() => {
    setTenants(props.tenants)
    if (props.tenants?.length === 1) {
      setTenant(props.tenants[0])
    }
  }, [props.tenants])

  const filterWhitelist = () => {
    if (whitelist?.length > 0) {
      let sortedWhitelist = [...whitelist];
      sortedWhitelist = sortedWhitelist.filter(item => moment(item.expiry_time).isAfter(moment()))
      if (search !== '') {
        sortedWhitelist = sortedWhitelist.filter(item => (
          item.license_plate.toLowerCase().indexOf(search.toLowerCase()) !== -1
        ))
      }
      
      if (sortBy === 'startdateDesc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.start_time && b.start_time && moment(a.start_time).isBefore(moment(b.start_time)) ? 1 : -1);
      }
      if (sortBy === 'startdateAsc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.start_time && b.start_time && moment(a.start_time).isBefore(moment(b.start_time)) ? -1 : 1);
      }
      if (sortBy === 'expiresDesc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.expiry_time && b.expiry_time && moment(a.expiry_time).isBefore(moment(b.expiry_time)) ? 1 : -1);
      }
      if (sortBy === 'expiresAsc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.expiry_time && b.expiry_time && moment(a.expiry_time).isBefore(moment(b.expiry_time)) ? -1 : 1);
      }
      if (sortBy === 'licenseAsc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => a.license_plate.localeCompare(b.license_plate));
      }
      if (sortBy === 'licenseDesc') {
        sortedWhitelist = sortedWhitelist.sort((a, b) => b.license_plate.localeCompare(a.license_plate));
      }
      return sortedWhitelist
    }
    
  }

  const whitelistAction = (item, action) => {
    if (action === 'remove_vehicle') {
      let confirm = window.confirm('Are you sure you want to remove this vehicle from the list?')
      if (confirm) {
        props.removeFromWhitelist(location, item)
      }
    }
    if (action === 'edit_vehicle') {
      editVehicle(item)
    }
  }

  const editVehicle = (item) => {
    setSelectedVehicle(item)
    setLicensePlate(item.license_plate)
    setLicensePlateState(item.license_plate_state)
    setStartDate(moment(item.start_time).toDate())
    setStartTime(moment(item.start_time).format("HH:mm"))
    setHowLong('today')
    setUntilADate(true)
    setEndDate(moment(item.expiry_time).toDate())
    setZone(item.zone)
    setShowAddVehicleModal(true)
  }

  const isValid = () => {
    let isValid = true
    if (licensePlate?.length < 3) {
      isValid = false
    }
    return isValid
  }

  const isImportValid = () => {
    let isValid = true
    if (!csvFile || csvFile.type !== 'text/csv') {
      isValid = false
    }
    return isValid
  }

  const calculateTimeFromNumbers = (numbers) => {
    let hours = Math.floor(numbers / 3600)
    let minutes = floor((numbers - (hours * 3600)) / 60)
    return {hours, minutes}
  }

  const addVehicleToWhitelist = () => {
    let data = {
      license_plate: licensePlate,
      license_plate_state: licensePlateState,
      zone: zone || null,
      tenant: tenant || null,
    }
    let adjustedStartDate = moment(startDate)
    adjustedStartDate = adjustedStartDate.set('hour', calculateTimeFromNumbers(startTime).hours)
    adjustedStartDate = adjustedStartDate.set('minute', calculateTimeFromNumbers(startTime).minutes)
    adjustedStartDate = adjustedStartDate.set('second', 0)

    let adjustedEndDate = moment(endDate)
    if (!untilADate) {
      if (howLong === 'today') {
        adjustedEndDate = moment(adjustedStartDate)
      }
      if (howLong === 'untilRemoved') {
        adjustedEndDate = moment('9990-12-31 00:00:00')
      }
      if (howLong !== 'today' && howLong !== 'untilRemoved') {
        adjustedEndDate = moment(adjustedStartDate).add(1, howLong)
      }
    }
    adjustedEndDate = adjustedEndDate.set('hour', 23)
    adjustedEndDate = adjustedEndDate.set('minute', 59)
    adjustedEndDate = adjustedEndDate.set('second', 59)

    data.start_time = moment(adjustedStartDate).utc().toISOString()
    data.expiry_time = moment(adjustedEndDate).utc().toISOString()
    data.space_number = "2"
    data.source = props.user.name
    props.addVehicleToWhitelist(location, data)
    setLicensePlate('')
    setLicensePlateState(location.state)
    setStartDate(moment().toDate())
    setStartTime(moment().format("HH:mm"))
    setHowLong('today')
    setUntilADate(false)
    setEndDate(moment().add(1, 'days').toDate())
    setZone(null)
    setTenant(null)
    setShowAddVehicleModal(false)
  }

  const editVehicleOnWhitelist = () => {
    let data = {
      license_plate: licensePlate,
      license_plate_state: licensePlateState,
      zone: zone || null,
      tenant: tenant || null,
    }
    let adjustedStartDate = moment(startDate)
    adjustedStartDate = adjustedStartDate.set('hour', calculateTimeFromNumbers(startTime).hours)
    adjustedStartDate = adjustedStartDate.set('minute', calculateTimeFromNumbers(startTime).minutes)
    adjustedStartDate = adjustedStartDate.set('second', 0)

    let adjustedEndDate = moment(endDate)
    if (!untilADate) {
      if (howLong === 'today') {
        adjustedEndDate = moment(adjustedStartDate)
      }
      if (howLong === 'untilRemoved') {
        adjustedEndDate = moment('9990-12-31 00:00:00')
      }
      if (howLong !== 'today' && howLong !== 'untilRemoved') {
        adjustedEndDate = moment(adjustedStartDate).add(1, howLong)
      }
    }
    adjustedEndDate = adjustedEndDate.set('hour', 23)
    adjustedEndDate = adjustedEndDate.set('minute', 59)
    adjustedEndDate = adjustedEndDate.set('second', 59)

    data.start_time = moment(adjustedStartDate).utc().toISOString()
    data.expiry_time = moment(adjustedEndDate).utc().toISOString()
    data.space_number = "2"
    data.source = props.user.name
    props.editVehicleOnWhitelist(selectedVehicle, location, data)
    setSelectedVehicle(null)
    setLicensePlate('')
    setLicensePlateState(location.state)
    setStartDate(moment().toDate())
    setStartTime(moment().format("HH:mm"))
    setHowLong('today')
    setUntilADate(false)
    setEndDate(moment().add(1, 'days').toDate())
    setZone(null)
    setTenant(null)
    setShowAddVehicleModal(false)
  }

  const saveLocationNotes = () => {
    props.editLocationNotes(location, notes)
    setShowNotesModal(false)
  }

  const importVehiclesToWhitelist = () => {
    let data = {
      zone: zone || null,
      tenant: tenant || null,
      csvFile: csvFile
    }
    let adjustedStartDate = moment(startDate)
    adjustedStartDate = adjustedStartDate.set('hour', calculateTimeFromNumbers(startTime).hours)
    adjustedStartDate = adjustedStartDate.set('minute', calculateTimeFromNumbers(startTime).minutes)
    adjustedStartDate = adjustedStartDate.set('second', 0)

    let adjustedEndDate = moment(endDate)
    if (!untilADate) {
      if (howLong === 'today') {
        adjustedEndDate = moment(adjustedStartDate)
      }
      if (howLong === 'untilRemoved') {
        adjustedEndDate = moment('9990-12-31 00:00:00')
      }
      if (howLong !== 'today' && howLong !== 'untilRemoved') {
        adjustedEndDate = moment(adjustedStartDate).add(1, howLong)
      }
    }
    adjustedEndDate = adjustedEndDate.set('hour', 23)
    adjustedEndDate = adjustedEndDate.set('minute', 59)
    adjustedEndDate = adjustedEndDate.set('second', 59)

    data.start_time = moment(adjustedStartDate).utc().toISOString()
    data.expiry_time = moment(adjustedEndDate).utc().toISOString()
    data.space_number = "2"
    data.source = props.user.name
    props.importVehiclesToWhitelist(location, data)
    setLicensePlate('')
    setLicensePlateState(location.state)
    setStartDate(moment().toDate())
    setStartTime(moment().format("HH:mm"))
    setHowLong('today')
    setUntilADate(false)
    setEndDate(moment().add(1, 'days').toDate())
    setZone(null)
    setTenant(null)
    setShowImportVehicleModal(false)
  }
  
  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}

      {/* First Row of Posts */}
      <Row>
        <Col>
          <Row noGutters className="page-header py-4">
            <PageTitle xs="12" sm="5" title={"Permitted vehicles: " + location.name} className="text-sm-left mb-3" />
            <Col xs="12" sm="7" className='text-right'>
              <Row>
                <Col className='text-right pl-0'>
                  {accessCheck(props.user, 'tenants') && (
                    <Button
                      theme="outline-accent"
                      onClick={() => window.location.href='/location/' + location.id + '/tenants'}
                      className={'mr-2 mb-2'}
                      style={{
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        color: '#21AA73',
                        fontWeight: '500',
                        transition: 'all 0.2s ease'
                      }}
                    >Manage tenants</Button>
                  )}
                  <Button
                    theme="outline-accent"
                    onClick={() => window.location.href='/location/' + location.id + '/zones'}
                    className={'mr-2 mb-2'}
                    style={{
                      borderColor: 'rgba(33, 170, 115, 0.3)',
                      color: '#21AA73',
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                  >Manage zones</Button>
                  <Button
                    theme="outline-accent"
                    onClick={() => window.location.href='/edit-location/' + location.id}
                    className={'mr-2 mb-2'}
                    style={{
                      borderColor: 'rgba(33, 170, 115, 0.3)',
                      color: '#21AA73',
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                  >Edit location</Button>
                  <Button
                    theme="outline-accent"
                    onClick={() => setShowImportVehicleModal(true)}
                    className={'mr-2 mb-2'}
                    style={{
                      borderColor: 'rgba(33, 170, 115, 0.3)',
                      color: '#21AA73',
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                  >Import vehicles</Button>
                  <Button
                    theme="outline-accent"
                    onClick={() => setShowNotesModal(true)}
                    className={'mr-2 mb-2'}
                    style={{
                      borderColor: 'rgba(33, 170, 115, 0.3)',
                      color: '#21AA73',
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                  >Notes</Button>
                  <Button
                    theme="accent"
                    className={'mb-2'}
                    onClick={() => setShowAddVehicleModal(true)}
                    style={{
                      fontWeight: '500',
                      boxShadow: '0 3px 10px rgba(33, 170, 115, 0.2)',
                      transition: 'all 0.2s ease'
                    }}
                  >Add vehicle</Button>
                </Col>
              </Row>
            </Col>
          </Row>
          {props.loadingWhitelist ? (
            <Row>
              <Col className={'text-center py-5'}>
                <ActivityIndicator />
                <p className="mt-3 text-muted">Loading vehicles...</p>
              </Col>
            </Row>
          ) : whitelist?.length === 0 ? (
            <>
              <Card small className="mb-4 mt-4" style={{
                borderRadius: '6px', 
                boxShadow: '0 1px 10px rgba(0,0,0,0.05)', 
                border: '1px solid #eaedf3'
              }}>
                <Row>
                  <Col xs={12} style={{paddingTop: 48, paddingBottom: 32, textAlign: 'center'}}>
                    <span style={{textAlign: 'center', fontWeight: 'bold', marginBottom: 12, fontSize: '18px', color: '#3D3C3E', display: 'block'}}>Get started and add some permitted vehicles</span>
                    <span style={{textAlign: 'center', fontSize: 14, color: '#6c757d', display: 'block', maxWidth: '400px', margin: '12px auto 0', lineHeight: '1.5'}}>
                      Permitted vehicles will not trigger a potential violation when the license plate is scanned by the enforcement officer.
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} style={{paddingBottom: 64, textAlign: 'center'}}>
                    <Button
                      theme="accent"
                      className={'mr-3'}
                      onClick={() => setShowAddVehicleModal(true)}
                      style={{
                        fontWeight: '500',
                        padding: '10px 20px',
                        boxShadow: '0 3px 10px rgba(33, 170, 115, 0.2)',
                        transition: 'all 0.2s ease'
                      }}
                    >Add vehicle</Button>
                    <Button
                      theme="outline-accent"
                      onClick={() => setShowImportVehicleModal(true)}
                      style={{
                        borderColor: 'rgba(33, 170, 115, 0.3)',
                        color: '#21AA73',
                        fontWeight: '500',
                        padding: '10px 20px',
                        transition: 'all 0.2s ease'
                      }}
                    >Import vehicles</Button>
                  </Col>
                </Row>
              </Card>
            </>
          ) : (
            <>
              <Card small className="mb-4 mt-4" style={{
                borderRadius: '6px', 
                boxShadow: '0 1px 10px rgba(0,0,0,0.05)', 
                border: '1px solid #eaedf3'
              }}>
                <CardHeader className="border-bottom bg-white">
                  <Row>
                    <Col xs={8}>
                      <h6 className="m-0 font-weight-bold">Permitted Vehicles</h6>
                    </Col>
                    <Col xs={4} className='text-right pl-0'>
                      <div className="search-container" style={{ position: 'relative', maxWidth: '100%' }}>
                        <FormInput 
                          type={'text'} 
                          className={'form-control'} 
                          placeholder={'Search vehicles...'} 
                          value={search} 
                          onChange={event => setSearch(event.target.value)}
                          style={{
                            padding: '10px 12px 10px 32px',
                            fontSize: '14px',
                            border: '1px solid #dfe3e9',
                            borderRadius: '4px',
                            backgroundColor: '#f8f9fa',
                            transition: 'all 0.2s ease',
                            outline: 'none'
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = '#fff';
                            e.target.style.boxShadow = '0 0 0 0.2rem rgba(33, 170, 115, 0.1)';
                            e.target.style.borderColor = 'rgba(33, 170, 115, 0.4)';
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = '#f8f9fa';
                            e.target.style.boxShadow = 'none';
                            e.target.style.borderColor = '#dfe3e9';
                          }}
                        />
                        <FontAwesomeIcon 
                          icon={faSearch} 
                          style={{
                            position: 'absolute',
                            left: '12px',
                            top: '12px',
                            color: '#818ea3',
                            transition: 'color 0.2s ease'
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="p-0">
                  <table className="table mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col" className="border-0">
                          <div onClick={() => setSortBy(sortBy !== 'licenseAsc' ? 'licenseAsc' : 'licenseDesc')} style={{cursor: 'pointer', fontWeight: '600', fontSize: '14px'}}>
                            License plate
                            {sortBy === 'licenseAsc' && <FontAwesomeIcon icon={faSortUp} className="ml-1" size="sm" />}
                            {sortBy === 'licenseDesc' && <FontAwesomeIcon icon={faSortDown} className="ml-1" size="sm" />}
                          </div>
                        </th>
                        <th scope="col" className="border-0 d-none d-md-table-cell">
                          <div onClick={() => setSortBy(sortBy !== 'idAsc' ? 'idAsc' : 'idDesc')} style={{cursor: 'pointer', fontWeight: '600', fontSize: '14px'}}>Source</div>
                        </th>
                        <th scope="col" className="border-0">
                          <div onClick={() => setSortBy(sortBy !== 'startdateDesc' ? 'startdateDesc' : 'startdateAsc')} style={{cursor: 'pointer', fontWeight: '600', fontSize: '14px'}}>
                            Start time
                            {sortBy === 'startdateDesc' && <FontAwesomeIcon icon={faSortDown} className="ml-1" size="sm" />}
                            {sortBy === 'startdateAsc' && <FontAwesomeIcon icon={faSortUp} className="ml-1" size="sm" />}
                          </div>
                        </th>
                        <th scope="col" className="border-0">
                          <div onClick={() => setSortBy(sortBy !== 'expiresDesc' ? 'expiresDesc' : 'expiresAsc')} style={{cursor: 'pointer', fontWeight: '600', fontSize: '14px'}}>
                            Expires
                            {sortBy === 'expiresDesc' && <FontAwesomeIcon icon={faSortDown} className="ml-1" size="sm" />}
                            {sortBy === 'expiresAsc' && <FontAwesomeIcon icon={faSortUp} className="ml-1" size="sm" />}
                          </div>
                        </th>
                        <th scope="col" className="border-0 d-none d-md-table-cell">
                          <div style={{fontWeight: '600', fontSize: '14px'}}>Zone</div>
                        </th>
                        <th scope="col" className="border-0 text-right">
                          <div style={{fontWeight: '600', fontSize: '14px'}}>Actions</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.whitelist && filterWhitelist()?.length > 0 && filterWhitelist()?.slice((page - 1) * pageSize, ((page - 1) * pageSize) + pageSize)?.map(item => {
                        return (
                          <tr key={item.id}>
                            <td style={{padding: '16px 12px'}}>
                              <span style={{fontWeight: '500'}}>{item.license_plate}</span>
                            </td>
                            <td style={{padding: '16px 12px'}} className="d-none d-md-table-cell">
                              {item.source}
                            </td>
                            <td style={{padding: '16px 12px'}}>
                              {moment(item.start_time).format('MM/DD/Y h:mm a')}
                            </td>
                            <td style={{padding: '16px 12px'}}>
                              {moment(item.expiry_time).diff(moment(), 'year') <= 0 ? (
                                moment(item.expiry_time).format('MM/DD/Y h:mm a')
                              ) : (
                                <span className="badge" style={{
                                  backgroundColor: 'rgba(33, 170, 115, 0.1)',
                                  color: '#21AA73',
                                  padding: '5px 8px',
                                  borderRadius: '4px',
                                  fontWeight: '500',
                                  fontSize: '12px'
                                }}>Permanent</span>
                              )}
                            </td>
                            <td style={{padding: '16px 12px'}} className="d-none d-md-table-cell">
                              {location.zones?.find(zone => zone.id === item.zone)?.name || (
                                <span className="text-muted">All zones</span>
                              )}
                            </td>
                            <td className="text-right" style={{padding: '8px 12px'}}>
                              <div className="d-flex justify-content-end">
                                <Button
                                  theme="white"
                                  size="sm"
                                  className="mr-2"
                                  style={{
                                    padding: '6px 12px',
                                    boxShadow: 'none',
                                    border: '1px solid #e1e5eb'
                                  }}
                                  onClick={() => whitelistAction(item, 'edit_vehicle')}
                                >
                                  Edit
                                </Button>
                                <Button
                                  theme="danger"
                                  outline
                                  size="sm"
                                  style={{
                                    padding: '6px 12px',
                                    boxShadow: 'none'
                                  }}
                                  onClick={() => whitelistAction(item, 'remove_vehicle')}
                                >
                                  Remove
                                </Button>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </CardBody>
              </Card>
              <Pagination
                data={filterWhitelist()}
                pageSize={pageSize}
                page={page}
                onPageChange={(newPage) => setPage(newPage)}      
              />
            </>
          )}
          
        </Col>
      </Row>
      <Modal size={'md'} open={showAddVehicleModal} toggle={() => setShowAddVehicleModal(false)}>
        <ModalHeader>{selectedVehicle?.id ? 'Edit' : 'Add'} a permitted vehicle</ModalHeader>
        <ModalBody className={'p-4'}>
          <Row form className={'mb-3'}>
            <Col xs={7} className="form-group">
              <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>Enter the license plate</label>
              <FormInput 
                type='text' 
                value={licensePlate} 
                onChange={(event) => setLicensePlate(event.target.value.toUpperCase().replace(/\s/gim, ''))}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #dfe3e9',
                  borderRadius: '4px',
                  transition: 'all 0.2s ease'
                }}
              />
            </Col>
            <Col xs={5} className="form-group">
              <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>Enter the State</label>
              <FormSelect 
                value={licensePlateState} 
                onChange={(event) => setLicensePlateState(event.target.value)}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #dfe3e9',
                  borderRadius: '4px',
                  transition: 'all 0.2s ease',
                  height: '44px'
                }}
              >
                {CONSTANTS.US_STATES.map(state => (
                  <option key={state.abbreviation} value={state.abbreviation}>{state.name}</option>
                ))}
                {CONSTANTS.CA_STATES.map(state => (
                  <option key={`CA-${state.abbreviation}`} value={state.abbreviation}>CA - {state.name}</option>
                ))}
              </FormSelect>
            </Col>
          </Row>
          
          {tenants?.length > 0 && (
            <Row form className={'mb-3'}>
              <Col xs={12} className="form-group">
                <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>Assign Vehicles to Tenant</label>
                <FormSelect
                  id="tenantSelect"
                  value={tenant}
                  onChange={(event) => setTenant(event.target.value)}
                  style={{
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid #dfe3e9',
                    borderRadius: '4px',
                    transition: 'all 0.2s ease',
                    height: '44px'
                  }}
                >
                  {tenants?.map(tenant => (
                    <option key={tenant.id} value={tenant.id}>{tenant.name}</option>
                  ))}
                </FormSelect>
              </Col>
            </Row>
          )}
          
          {location?.zones?.length > 0 && (
            <Row form className={'mb-3'}>
              <Col xs={12} className="form-group">
                <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>Which zone is the vehicle permitted in</label>
                <FormSelect 
                  value={zone} 
                  onChange={(event) => setZone(event.target.value)}
                  style={{
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid #dfe3e9',
                    borderRadius: '4px',
                    transition: 'all 0.2s ease',
                    height: '44px'
                  }}
                >
                  <option value={null}>All zones</option>
                  {location?.zones?.map(zone => (
                    <option value={zone.id}>{zone.name}</option>
                  ))}
                </FormSelect>
              </Col>
            </Row>
          )}
          <Row form className={'mb-3'}>
            <Col xs={12} className="form-group">
              <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>When would you like to add the vehicle</label>
            </Col>
          </Row>
          <Row form className={'mb-3'}>
            <Col xs={7}>
              <InputGroup seamless className="mb-2" style={{ borderRadius: 4 }}>
                <DatePicker
                  className={'form-control'}
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  todayButton="Today"
                  shouldCloseOnSelect={false}
                  customInput={
                    <FormInput style={{ height: '44px' }} />
                  }
                  style={{
                    width: '100%',
                    borderRadius: '4px 0 0 4px',
                    border: '1px solid #E9ECEF',
                    padding: '10px 12px',
                    fontSize: '14px',
                    height: '44px'
                  }}
                />
                <InputGroupAddon type="append">
                  <InputGroupText style={{
                    backgroundColor: '#F8F9FA',
                    border: '1px solid #E9ECEF',
                    borderLeft: 'none'
                  }}>
                    <span style={{ fontSize: 18, color: '#21AA73' }}><EventNoteIcon fontSize={'inherit'} /></span>
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </Col>
            <Col xs={5}>
              <TimePicker 
                start="00:00" 
                end="23:55" 
                step={5} 
                value={startTime} 
                onChange={(time) => setStartTime(time)}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #dfe3e9',
                  borderRadius: '4px',
                  transition: 'all 0.2s ease',
                  height: '44px'
                }}
              />
            </Col>
          </Row>
          {!untilADate && (
            <>
              <Row form className={'mb-3'}>
                <Col xs={12} className="form-group">
                  <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>How long should the vehicle be valid for?</label>
                </Col>
              </Row>
              <Row form className={'mb-3'}>
                <Col xs={7} className="form-group">
                  <FormSelect 
                    value={howLong} 
                    onChange={(event) => setHowLong(event.target.value)}
                    style={{
                      padding: '10px 12px',
                      fontSize: '14px',
                      border: '1px solid #dfe3e9',
                      borderRadius: '4px',
                      transition: 'all 0.2s ease',
                      height: '44px'
                    }}
                  >
                    <option value={'today'}>Today only</option>
                    <option value={'week'}>1 week</option>
                    <option value={'month'}>1 month</option>
                    <option value={'year'}>1 year</option>
                    <option value={'untilRemoved'}>Until removed</option>
                  </FormSelect>
                </Col>
                <Col xs={5} className="form-group pt-4">
                  <FormCheckbox 
                    checked={untilADate} 
                    onChange={() => setUntilADate(!untilADate)}
                    style={{
                      fontSize: '14px',
                      color: '#495057'
                    }}
                  >
                    Until a specific date
                  </FormCheckbox>
                </Col>
              </Row>
            </>
          )}
          {untilADate && (
            <Row form className={'mb-3'}>
              <Col xs={7} className="form-group">
                <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>Select an end date</label>
                <InputGroup seamless style={{borderRadius: 4}}>
                  <DatePicker
                    className={'form-control'}
                    selected={endDate}
                    minDate={startDate}
                    onChange={(date) => setEndDate(date)}
                    shouldCloseOnSelect={false}
                    customInput={
                      <FormInput style={{ height: '44px' }} />
                    }
                    style={{
                      width: '100%',
                      borderRadius: '4px 0 0 4px',
                      border: '1px solid #E9ECEF',
                      padding: '10px 12px',
                      fontSize: '14px',
                      height: '44px'
                    }}
                  />
                  <InputGroupAddon type="append">
                    <InputGroupText style={{
                      backgroundColor: '#F8F9FA',
                      border: '1px solid #E9ECEF',
                      borderLeft: 'none'
                    }}>
                      <span style={{ fontSize: 18, color: '#21AA73' }}><EventNoteIcon fontSize={'inherit'} /></span>
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <Col xs={5} className="form-group pt-4">
                <FormCheckbox 
                  checked={untilADate} 
                  onChange={() => setUntilADate(!untilADate)}
                  style={{
                    fontSize: '14px',
                    color: '#495057'
                  }}
                >
                  Until a specific date
                </FormCheckbox>
              </Col>
            </Row>  
          )}
        </ModalBody>
        <ModalFooter style={{display: 'block !important', padding: '1rem 1.5rem', borderTop: '1px solid #dfe1e3'}}>
          <Row>
            <Col xs={6} className={'text-left'}>
              <Button
                theme="light"
                onClick={() => setShowAddVehicleModal(false)}
                className={'mr-2'}
                style={{
                  fontWeight: '500',
                  padding: '0.5rem 1rem',
                  boxShadow: 'none'
                }}
              >Cancel</Button>
                  
            </Col>
            <Col xs={6} className={'text-right'}>
              <Button
                theme="accent"
                disabled={!isValid()}
                onClick={() => selectedVehicle?.id ? editVehicleOnWhitelist() : addVehicleToWhitelist()}
                style={{
                  fontWeight: '500',
                  padding: '0.5rem 1rem',
                  boxShadow: '0 3px 10px rgba(33, 170, 115, 0.2)'
                }}
              >Save</Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>      
      <Modal size={'md'} open={showImportVehicleModal} toggle={() => setShowImportVehicleModal(false)}>
        <ModalHeader style={{
          position: 'sticky',
          top: 0,
          backgroundColor: '#fff',
          zIndex: 1,
          borderBottom: '1px solid #E9ECEF'
        }}>Import Permitted Vehicles</ModalHeader>
        <ModalBody className={'p-4'} style={{
          maxHeight: 'calc(100vh - 130px)',
          overflowY: 'auto',
          overflowX: 'hidden'
        }}>
          <div style={{ marginBottom: '32px' }}>
            <h6 style={{
              fontSize: '15px',
              color: '#3D5170',
              fontWeight: '600',
              marginBottom: '16px'
            }}>Upload CSV File</h6>
            <div className="csv-upload-container" style={{
              border: '2px dashed #E9ECEF',
              borderRadius: '8px',
              padding: '24px',
              textAlign: 'center',
              backgroundColor: '#F8F9FA',
              transition: 'all 0.2s ease',
              position: 'relative'
            }}>
              <FormInput
                id="csvUpload"
                type={'file'}
                accept=".csv"
                onChange={(event) => setCsvFile(event.target.files[0])}
                style={{
                  border: 'none',
                  backgroundColor: 'transparent',
                  padding: '0'
                }}
              />
              <small className="text-muted mt-3 d-block">
                {csvFile ? csvFile.name : 'Select or drag a CSV file here'}
              </small>
              <div style={{ position: 'absolute', top: '12px', right: '12px' }}>
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  style={{
                    color: '#21AA73',
                    cursor: 'pointer'
                  }}
                  onClick={() => setShowCsvTooltip(!showCsvTooltip)}
                />
                {showCsvTooltip && (
                  <div style={{
                    position: 'absolute',
                    top: 'calc(100% + 10px)',
                    right: '0',
                    backgroundColor: '#fff',
                    padding: '12px 16px',
                    borderRadius: '6px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    border: '1px solid #E9ECEF',
                    width: '280px',
                    zIndex: 1000,
                    fontSize: '13px',
                    color: '#3D5170',
                    whiteSpace: 'normal'
                  }}>
                    <div style={{ marginBottom: '8px' }}>
                      Upload a CSV file containing vehicle information. The file should have two columns with headers:
                    </div>
                    <ul style={{
                      listStyle: 'none',
                      padding: 0,
                      margin: '0'
                    }}>
                      <li style={{ marginBottom: '4px' }}>
                        • "license plate" - The vehicle's license plate number
                      </li>
                      <li>
                        • "state" - The state/province of registration
                      </li>
                    </ul>
                    <div style={{
                      position: 'absolute',
                      top: '-6px',
                      right: '10px',
                      transform: 'translateX(-50%) rotate(45deg)',
                      width: '12px',
                      height: '12px',
                      backgroundColor: '#fff',
                      border: '1px solid #E9ECEF',
                      borderBottom: 'none',
                      borderRight: 'none'
                    }}></div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {tenants?.length > 0 && (
            <div style={{ marginBottom: '32px' }}>
              <h6 style={{
                fontSize: '15px',
                color: '#3D5170',
                fontWeight: '600',
                marginBottom: '16px'
              }}>Assign Vehicles to Tenant</h6>
              <FormSelect
                id="tenantSelect"
                value={tenant}
                onChange={(event) => setTenant(event.target.value)}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #E9ECEF',
                  borderRadius: '4px',
                  backgroundColor: '#FFFFFF',
                  transition: 'all 0.2s ease',
                  height: '44px'
                }}
              >
                {tenants?.map(tenant => (
                  <option key={tenant.id} value={tenant.id}>{tenant.name}</option>
                ))}
              </FormSelect>
            </div>
          )}

          {location?.zones?.length > 0 && (
            <div style={{ marginBottom: '32px' }}>
              <h6 style={{
                fontSize: '15px',
                color: '#3D5170',
                fontWeight: '600',
                marginBottom: '16px'
              }}>Permitted Zone</h6>
              <FormSelect
                id="zoneSelect"
                value={zone}
                onChange={(event) => setZone(event.target.value)}
                style={{
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #E9ECEF',
                  borderRadius: '4px',
                  backgroundColor: '#FFFFFF',
                  transition: 'all 0.2s ease',
                  height: '44px'
                }}
              >
                <option value={null}>All zones</option>
                {location?.zones?.map(zone => (
                  <option key={zone.id} value={zone.id}>{zone.name}</option>
                ))}
              </FormSelect>
            </div>
          )}

          <div style={{ marginBottom: '32px' }}>
            <h6 style={{
              fontSize: '15px',
              color: '#3D5170',
              fontWeight: '600',
              marginBottom: '16px'
            }}>Start Date & Time</h6>
            <Row>
              <Col xs={7}>
                <InputGroup seamless className="mb-2" style={{ borderRadius: 4 }}>
                  <DatePicker
                    className={'form-control'}
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    todayButton="Today"
                    shouldCloseOnSelect={false}
                    customInput={
                      <FormInput style={{ height: '44px' }} />
                    }
                    style={{
                      width: '100%',
                      borderRadius: '4px 0 0 4px',
                      border: '1px solid #E9ECEF',
                      padding: '10px 12px',
                      fontSize: '14px',
                      height: '44px'
                    }}
                  />
                  <InputGroupAddon type="append">
                    <InputGroupText style={{
                      backgroundColor: '#F8F9FA',
                      border: '1px solid #E9ECEF',
                      borderLeft: 'none'
                    }}>
                      <span style={{ fontSize: 18, color: '#21AA73' }}><EventNoteIcon fontSize={'inherit'} /></span>
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <Col xs={5}>
                <TimePicker 
                  start="00:00" 
                  end="23:55" 
                  step={5} 
                  value={startTime} 
                  onChange={(time) => setStartTime(time)}
                  style={{
                    padding: '10px 12px',
                    fontSize: '14px',
                    border: '1px solid #dfe3e9',
                    borderRadius: '4px',
                    transition: 'all 0.2s ease',
                    height: '44px'
                  }}
                />
              </Col>
            </Row>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <h6 style={{
              fontSize: '15px',
              color: '#3D5170',
              fontWeight: '600',
              marginBottom: '16px'
            }}>End</h6>
            {!untilADate ? (
              <Row>
                <Col xs={8}>
                  <FormSelect
                    value={howLong}
                    onChange={(event) => setHowLong(event.target.value)}
                    style={{
                      padding: '10px 12px',
                      fontSize: '14px',
                      border: '1px solid #E9ECEF',
                      borderRadius: '4px',
                      backgroundColor: '#FFFFFF',
                      height: '44px'
                    }}
                  >
                    <option value={'today'}>Today only</option>
                    <option value={'week'}>1 week</option>
                    <option value={'month'}>1 month</option>
                    <option value={'year'}>1 year</option>
                    <option value={'untilRemoved'}>Until removed</option>
                  </FormSelect>
                </Col>
                <Col xs={4} className="d-flex align-items-center">
                  <FormCheckbox
                    checked={untilADate}
                    onChange={() => setUntilADate(!untilADate)}
                    style={{
                      fontSize: '14px',
                      color: '#3D5170',
                      marginBottom: 0
                    }}
                  >
                    Custom date
                  </FormCheckbox>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col xs={8}>
                  <InputGroup seamless style={{ borderRadius: 4 }}>
                    <DatePicker
                      className={'form-control'}
                      selected={endDate}
                      minDate={startDate}
                      onChange={(date) => setEndDate(date)}
                      shouldCloseOnSelect={false}
                      customInput={
                        <FormInput style={{ height: '44px' }} />
                      }
                      style={{
                        width: '100%',
                        borderRadius: '4px 0 0 4px',
                        border: '1px solid #E9ECEF',
                        padding: '10px 12px',
                        fontSize: '14px',
                        height: '44px'
                      }}
                    />
                    <InputGroupAddon type="append">
                      <InputGroupText style={{
                        backgroundColor: '#F8F9FA',
                        border: '1px solid #E9ECEF',
                        borderLeft: 'none'
                      }}>
                        <span style={{ fontSize: 18, color: '#21AA73' }}><EventNoteIcon fontSize={'inherit'} /></span>
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
                <Col xs={4} className="d-flex align-items-center">
                  <FormCheckbox
                    checked={untilADate}
                    onChange={() => setUntilADate(!untilADate)}
                    style={{
                      fontSize: '14px',
                      color: '#3D5170',
                      marginBottom: 0
                    }}
                  >
                    Custom date
                  </FormCheckbox>
                </Col>
              </Row>
            )}
          </div>
        </ModalBody>
        <ModalFooter style={{
          display: 'block !important',
          padding: '1rem 1.5rem',
          borderTop: '1px solid #E9ECEF',
          backgroundColor: '#FFFFFF',
          position: 'sticky',
          bottom: 0,
          zIndex: 1
        }}>
          <Row>
            <Col xs={6} className={'text-left'}>
              <Button
                theme="light"
                onClick={() => setShowImportVehicleModal(false)}
                className={'mr-2'}
                style={{
                  fontWeight: '500',
                  padding: '0.75rem 1.25rem',
                  boxShadow: 'none'
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs={6} className={'text-right'}>
              <Button
                theme="accent"
                disabled={!isImportValid()}
                onClick={() => importVehiclesToWhitelist()}
                style={{
                  fontWeight: '500',
                  padding: '0.75rem 1.25rem',
                  boxShadow: '0 3px 10px rgba(33, 170, 115, 0.2)'
                }}
              >
                Import Vehicles
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Modal size={'md'} open={showNotesModal} toggle={() => setShowNotesModal(false)}>
        <ModalHeader>Location notes</ModalHeader>
        <ModalBody className={'p-4'}>
          <Row form className={'mb-3'}>
            <Col xs={12} className="form-group">
              <label className="form-label-custom" style={{fontWeight: '500', fontSize: '14px', color: '#495057', marginBottom: '8px'}}>
                Location Notes 
                <span className="text-muted ml-1" style={{fontWeight: 'normal', fontSize: '12px'}}>
                  (will appear in the mobile app)
                </span>
              </label>
              <FormTextarea
                id={'notes'}
                placeholder={'Enter text to appear in the notes section of the app'}
                value={notes}
                style={{
                  height: 150,
                  padding: '10px 12px',
                  fontSize: '14px',
                  border: '1px solid #dfe3e9',
                  borderRadius: '4px',
                  transition: 'all 0.2s ease'
                }}
                onChange={(event) => setNotes(event.target.value)}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter style={{display: 'block !important', padding: '1rem 1.5rem', borderTop: '1px solid #dfe1e3'}}>
          <Row>
            <Col xs={6} className={'text-left'}>
              <Button
                theme="light"
                onClick={() => setShowNotesModal(false)}
                className={'mr-2'}
                style={{
                  fontWeight: '500', 
                  padding: '0.5rem 1rem',
                  boxShadow: 'none'
                }}
              >Cancel</Button>
            </Col>
            <Col xs={6} className={'text-right'}>
              <Button
                theme="accent"
                onClick={() => saveLocationNotes()}
                style={{
                  fontWeight: '500', 
                  padding: '0.5rem 1rem',
                  boxShadow: '0 3px 10px rgba(33, 170, 115, 0.2)'
                }}
              >Save</Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </Container>
  );
}

export default PermittedVehicles;
